export default {
  Location: 'location',
  JobGroup: 'jobGroup',
  JobReason: 'jobReason',
  AssetCategory: 'assetCategory',
  Asset: 'asset',
}
